<template>
  <div class="svg__custom-boxmain" ref="scrollV">
    <Header :logoUrl="logoUrl" />
    <button
      v-if="activeSlug && !pinVisible"
      class="btn-locate-pin"
      @click="scrollToActivePin"
    >
      📍 Ver ubicación
    </button>
    <div style="width: 100%">
      <div class="svg__box" ref="scrollH">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 4794 4716"
          xml:space="preserve"
          @click="showCoordinatesOnConsole"
        >
          <!-- Placeholder borroso, inline (no requiere red, aparece de
               inmediato) — recrea el efecto de "revelado" que tenía el JPEG
               progresivo original antes de convertirlo a WebP. -->
          <image
            v-if="!imageLoaded"
            width="100%"
            height="4716"
            :xlink:href="blurPlaceholder"
            style="filter: blur(8px); transform: scale(1.02); transform-origin: center;"
          ></image>
          <image
            ref="svgImage"
            width="100%"
            height="4716"
            xlink:href="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/masterplan/Plan_Maestro_2026_progressive.webp"
            @load="imageLoaded = true; planMaestroImageLoadedSet(); scrollToActivePin()"
          ></image>
          <polygon
            v-for="(location, index) in locations"
            :key="index"
            :points="location.coords"
            class="polygon__map-main"
            :name="`${location.name}`"
          />
          <path  v-for="(locat, index) in locations"
            :key="`${index}-pin`"
            class="pin-element"
            :class="{ 'pin-active': locat.slug === activeSlug }"
            :id="locat.slug === activeSlug ? 'active-pin' : undefined"
            :d="locat.pin"
            :fill="locat.slug === activeSlug ? '#e63946' : '#152541'"
          />
        </svg>
        <tippy
          theme="toolMapMain"
          trigger="mouseenter"
          multiple="true"
          arrow="true"
          :placement="`${location.position}`"
          interactive="true"
          animation="fade"
          allowHTML="true"
          v-for="(location, index) in locations"
          :key="index"
          :to="`${location.name}`"
        >
        
          <tooltip-map-main :location="location" />
        </tippy>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../core/Header";
import TooltipMapMain from "../core/TooltipMapMain";
import { locationsData } from "../../utils/data_map_home.js";
import {
  faXmark,
  faArrowDown,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

// Miniatura de 40x39px del Plan Maestro (~2.7KB), embebida para que se vea
// de inmediato sin ninguna petición de red — placeholder mientras baja el
// WebP completo.
// Sobrevive a que el componente se destruya/recree al navegar fuera y
// volver a Home — así la segunda vez no se ve el blur (aunque la imagen
// ya esté cacheada por el navegador, imageLoaded siempre arrancaría en
// false en una instancia nueva del componente si no fuera por esto).
let planMaestroImageLoaded = false;

const BLUR_PLACEHOLDER =
  "data:image/jpeg;base64,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";

export default {
  name: "Home",
  data() {
    return {
      logoUrl: require("../../assets/img/core/logo.png"),
      locations: locationsData,
      name: "",
      closeIcon: faXmark,
      downIcon: faArrowDown,
      upIcon: faArrowUp,
      leftIcon: faArrowLeft,
      rightIcon: faArrowRight,
      coordinates: [], // Lista para almacenar las coordenadas (solo en memoria)
      imageLoaded: planMaestroImageLoaded,
      blurPlaceholder: BLUR_PLACEHOLDER,
      pinVisible: false,
      pinObserver: null,
      autoScrollDone: false,
    };
  },
  components: {
    Header,
    TooltipMapMain,
  },
  watch: {
    pinVisible(visible) {
      if (!visible && !this.autoScrollDone) {
        this.autoScrollDone = true;
        this.scrollToActivePin();
      }
    },
  },
  computed: {
    activeSlug() {
      return this.$route.query.slug || null;
    },
  },
  methods: {
    planMaestroImageLoadedSet() {
      planMaestroImageLoaded = true;
    },
    scrollToActivePin() {
      if (!this.activeSlug) return;
      const pin = document.getElementById('active-pin');
      if (!pin) return;
      const scrollV = this.$refs.scrollV;
      const scrollH = this.$refs.scrollH;
      if (!scrollV || !scrollH) return;
      const rect = pin.getBoundingClientRect();
      const containerVRect = scrollV.getBoundingClientRect();
      const containerHRect = scrollH.getBoundingClientRect();
      const top = scrollV.scrollTop + rect.top - containerVRect.top - scrollV.clientHeight / 2 + rect.height / 2;
      const left = scrollH.scrollLeft + rect.left - containerHRect.left - scrollH.clientWidth / 2 + rect.width / 2;
      scrollV.scrollTo({ top, behavior: 'smooth' });
      scrollH.scrollTo({ left, behavior: 'smooth' });
      this.observeActivePin();
    },
    observeActivePin() {
      if (!this.activeSlug) return;
      const pin = document.getElementById('active-pin');
      if (!pin) return;
      if (this.pinObserver) this.pinObserver.disconnect();
      this.pinObserver = new IntersectionObserver(
        ([entry]) => { this.pinVisible = entry.isIntersecting; },
        { threshold: 0.5 }
      );
      this.pinObserver.observe(pin);
    },
    showCoordinatesOnConsole(event) {
          const svg = event.target.closest('svg');
          const point = svg.createSVGPoint();

          point.x = event.clientX;
          point.y = event.clientY;

          const svgPoint = point.matrixTransform(svg.getScreenCTM().inverse());

          // Guardar coordenadas en la lista
          this.coordinatesList.push(`${svgPoint.x.toFixed(2)},${svgPoint.y.toFixed(2)}`);

          // Imprimir TODAS las coordenadas en un string
          //const output = this.coordinatesList.join(' ');
          //console.log(output);
        },
  },
  mounted() {
    // Fallback: si la imagen ya estaba en caché y @load no dispara, intentamos igual
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        this.scrollToActivePin();
        this.observeActivePin();
      });
    });
  },
  beforeDestroy() {
    if (this.pinObserver) this.pinObserver.disconnect();
  },
};
</script>

<style lang="css" scoped>
.btn-locate-pin {
  position: fixed;
  top: 80px;
  left: 16px;
  z-index: 100;
  background: #e63946;
  color: #fff;
  border: none;
  border-radius: 24px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  animation: fadeInUp 0.25s ease;
}

.btn-locate-pin:hover {
  background: #c1121f;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateX(-12px); }
  to   { opacity: 1; transform: translateX(0); }
}

.pin-active {
  transform-box: fill-box;
  transform-origin: bottom center;
  animation: pinPulse 1.2s ease-in-out infinite;
}

@keyframes pinPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.35);
    opacity: 0.75;
  }
}
</style>
